
import type { Database } from '@/integrations/supabase/types';

export type WebsiteSection = Database['public']['Enums']['website_section'];

export interface SectionWithSubsection {
  section: WebsiteSection;
  subsection?: string;
}

export const sectionLabels: any = {
  // Main Sections (NS1-NS8)
  'new-banner': 'NS1 - Banner (NewBanner)',
  'meine-vision': 'NS1b - Weil eure Geschichte zählt (MeineVision)',
  'section-two': 'NS2 - Deine Situation (NewSectionTwo)',
  'section-three': 'NS3 - Der perfekte Coach (SectionThree)',
  'section-four': 'NS4 - Erfahrungsberichte (NewSectionFive)',
  'section-five': 'NS5 - Meine Vision (MichErleben)',
  'about-me': 'NS6 - Über Mich (AboutMe)',
  'coaching-camps': 'NS7 - Orientierungs-Naturcamps',
  'next-steps': 'NS8 - Nächste Schritte (NextSteps)',
  
  // NS2 Subsections (Deine Situation)
  'abiturient': 'NS2a - Abiturient',
  'student': 'NS2b - Student',
  'professional': 'NS2c - Professional',
  
  // NS3 Subsections (Der perfekte Coach)
  'pfarrer': 'NS3a - Pfarrer',
  'begleitung': 'NS3b - Begleitung',
  'strategie': 'NS3c - Strategie',
  'vision': 'NS3e - Einzigartige Kombi',
  
  // NS7 Subsections (Orientierungs-Naturcamps)
  'ns7-banner': 'NS7 - Banner (Mitte oben)',
  'ns7-video': 'NS7 - Video Kurzüberblick (Links unten)',
  'ns7-info': 'NS7 - Detailinfos (Rechts unten)',
  'coaching-camps-info': 'NS7a - Camp Infos (6 Bilder)',
  
  // NS6 Images (Über Mich Bilder)
  'about-me-banner': 'NS6 - Über Mich (Hauptbild)',
  'about-me-preaching': 'NS6 - Über Mich (Predigt & Poetry)',
  'about-me-passions': 'NS6 - Über Mich (Hobbies)',
  
  // Internal References (R1-R6)
  'section-six': 'R6 - Über Mich Videos (AboutMeVideos)',
  'passions': 'R3 - Meine Leidenschaften (Passions)',
  'testimonials': 'R5 - Mein bewährter Approach (NewSectionFour)',
  'beliefs': 'R6 - Beliefs/Resterampe (Beliefs)',
  
  // Meta Images
  'meta-image': 'Metadaten Bilder (OG/Twitter)',
  
  // Legacy (zu entfernen)
  'banner': 'Legacy: Banner (zu entfernen)',
  'your-path': 'Legacy: Your Path (zu entfernen)',
  'contact': 'Legacy: Contact (zu entfernen)',
  'section-two-b': 'Legacy: Section 2B (zu entfernen)'
};

export const groupedSections = {
  mainSections: Object.entries(sectionLabels).filter(([key]) => 
    ['new-banner', 'meine-vision', 'section-two', 'section-three', 'section-four', 'section-five', 'about-me', 'coaching-camps', 'next-steps'].includes(key)
  ),
  
  ns2Sections: Object.entries(sectionLabels).filter(([key]) => 
    ['abiturient', 'student', 'professional'].includes(key)
  ),
  
  ns3Sections: Object.entries(sectionLabels).filter(([key]) => 
    ['pfarrer', 'begleitung', 'strategie', 'vision'].includes(key)
  ),
  
  ns7Sections: Object.entries(sectionLabels).filter(([key]) => 
    ['ns7-banner', 'ns7-video', 'ns7-info', 'coaching-camps-info'].includes(key)
  ),
  
  ns6Sections: Object.entries(sectionLabels).filter(([key]) => 
    ['about-me-banner', 'about-me-preaching', 'about-me-passions'].includes(key)
  ),
  
  internalSections: Object.entries(sectionLabels).filter(([key]) => 
    ['section-six', 'passions', 'testimonials', 'beliefs'].includes(key)
  ),
  
  metaSections: Object.entries(sectionLabels).filter(([key]) => 
    ['meta-image'].includes(key)
  ),
  
  legacySections: Object.entries(sectionLabels).filter(([key]) => 
    ['banner', 'your-path', 'contact', 'section-two-b'].includes(key)
  )
};
